'use strict';

exports.__esModule = true;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _hoistNonReactStatics = require('hoist-non-react-statics');
var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
var _BreakpointsContext = require("./BreakpointsContext");
var _BreakpointsContext2 = _interopRequireDefault(_BreakpointsContext);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var withBreakpoints = function withBreakpoints(Component) {
  // Remove conditional application of forwardRef in 4.0
  var C = _react2.default.forwardRef ? _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(_BreakpointsContext.Consumer, null, function (context) {
      return _react2.default.createElement(Component, _extends({}, props, {
        ref: ref
      }, context));
    });
  }) : function (props) {
    return _react2.default.createElement(_BreakpointsContext.Consumer, null, function (context) {
      return _react2.default.createElement(Component, _extends({}, props, context));
    });
  };
  C.displayName = 'withBreakpoints(' + (Component.displayName || Component.name) + ')';
  return (0, _hoistNonReactStatics2.default)(C, Component);
};
exports.default = withBreakpoints;